//import gliderJS from './glider.min.js';
import navigation from './navigation.js';

window.addEventListener('load', function(){
  /*
    new Glider(document.querySelector('.glider'), {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: '#dots'
      });
 */



  var elements = document.getElementsByClassName("Media-wide");
for (var i = 0; i < elements.length; i++) {
   //newHeight = elements.item(i).closest(".Media-body").clientHeight + 40;
   let newHeight = elements.item(0).querySelector(".Media-body").clientHeight + 60;
   
    if (elements.item(i).querySelector(".Media-bg")){
    elements.item(i).querySelector(".Media-bg").style.height = newHeight + "px";
    }
}
})



/*
function showMore(){
    //removes the link
    document.getElementById('showmorelink').style.display = "none";
    //shows the #more
    document.getElementById('showMore').style.display = "block";
}

document.getElementById("showmorelink").addEventListener('click', function(event){
  //event.preventDefault();
  showMore();
})
  */



  const images = document.querySelectorAll('.image-swap');

  images.forEach(img => {
    img.addEventListener('mouseenter', () => {
      img.src = img.dataset.hover;
    });

    img.addEventListener('mouseleave', () => {
      img.src = img.dataset.original;
    });
});        


window.addEventListener("load", function () {


    // Function to handle intersecting entries
    const handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
        console.log("a");
        /*
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          // You can unobserve the target if you want the animation to occur only once
          observer.unobserve(entry.target);
          console.log("b");
        }
        */
        if (entry.intersectionRatio > 0.15) {
        //if (entry.intersectionRatio > 0) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
            console.log("b");
            console.log(entry);
          } else {
           // entry.target.classList.add('remove');
          }        
      });
    };
  
    // Options for the observer (optional)
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.15 // Trigger when 10% of the element is visible
    };
  
    // Create an observer instance
    const observer = new IntersectionObserver(handleIntersect, options);
  
    // Target all elements with the class 'enter'
    const targets = document.querySelectorAll('.enter');
    console.log(targets);
    console.log("c - enter");
    targets.forEach(target => observer.observe(target));

    
  });
  

  /* STICKY NAV */
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('#masthead');
    const siteHeader = document.querySelector('.site-header');
    const topNavBar = document.querySelector('.top-nav-bar');

    // Tracks the last known scroll position
    let lastScrollTop = 0;
    // Threshold in pixels before the header starts changing (optional)
    const scrollThreshold = 50;
  
    window.addEventListener('scroll', () => {
      // Get the current vertical scroll position
      const currentScroll = window.scrollY || document.documentElement.scrollTop;
  
      // --- Part 1: Handle Margin Reduction on Scroll ---
      // If the user has scrolled past the threshold, apply the .scrolled class
      if (currentScroll > scrollThreshold) {
        header.classList.add('scrolled');
      } else {
        // If they scroll back to the very top, remove it
        header.classList.remove('scrolled');
      }
  
      // --- Part 2: Hide/Show top-nav-bar based on direction ---
  
      // Scrolling DOWN
      // Check if current scroll is greater than last scroll position
      if (currentScroll > lastScrollTop && currentScroll > scrollThreshold) {
        // Add a class to hide the top-nav-bar
        topNavBar.classList.add('hide-top-bar');
      }
      // Scrolling UP
      // Check if current scroll is less than last scroll position
      // And that we are not at the very top (currentScroll > 0)
      else if (currentScroll < lastScrollTop && currentScroll > 0) {
        // Remove the class to show the top-nav-bar
        topNavBar.classList.remove('hide-top-bar');
      }
  
      // Update the last known scroll position for the next scroll event
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
  });